import Swiper from 'swiper';
import { Mousewheel } from 'swiper/modules';
import debounce from 'lodash/debounce';
import 'swiper/css';

import { DURATION } from '../config.js';
import { lockSwipers } from './lock-swipers.js';
import { handleStaticSlide } from './static-slides.js';
import { handleHashNavigation, initMenuNavigation } from './anchor-slides.js';

let isProgrammaticSlide = false;
export function setProgrammaticSlide(state) {
  isProgrammaticSlide = state;
}

let verticalInstances = [];
let horizontalInstances = [];

function enableSwiper() {
  if (verticalInstances.length > 0) return;

  // Всі вертикальні контейнери
  const verticals = document.querySelectorAll('.swiper.vertical');
  verticals.forEach(el => {
    const instance = new Swiper(el, {
      direction: 'vertical',
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: false,
        sensitivity: 1,
        thresholdDelta: 60,
        thresholdTime: DURATION + 100,
      },
      modules: [Mousewheel],
      speed: DURATION,
      slidesPerView: 1,
      simulateTouch: false,
      touchReleaseOnEdges: true,
    });

    let canScroll = true;
    let startY = 0;

    function blockScroll() {
      canScroll = false;
      setTimeout(() => {
        canScroll = true;
      }, DURATION);
    }

    instance.on('slideChangeTransitionStart', () => {
      lockSwipers(horizontalInstances, true);
    });
    instance.on('slideChangeTransitionEnd', () => {
      lockSwipers(horizontalInstances, false);
    });

    instance.on('slidePrevTransitionStart', () => {
      const active = instance.slides[instance.activeIndex + 1];
      handleStaticSlide(instance, active, 'prev');
      blockScroll();
    });
    instance.on('slideNextTransitionStart', () => {
      const active = instance.slides[instance.previousIndex];
      handleStaticSlide(instance, active, 'next');
      blockScroll();
    });

    const debouncedWheel = debounce(e => {
      if (!canScroll) return;
      // Твій код для wheel
      const delta = e.deltaY;
      if (instance.activeIndex === 0 && delta < 0) {
        const active = instance.slides[instance.activeIndex];
        handleStaticSlide(instance, active, 'first');
      }
      blockScroll();
    }, 200);

    el.addEventListener('wheel', debouncedWheel);

    el.addEventListener('touchstart', e => {
      startY = e.touches[0].clientY;
    });

    el.addEventListener('touchend', e => {
      if (!canScroll) return;

      const endY = e.changedTouches[0].clientY;
      const delta = startY - endY;

      if (instance.activeIndex === 0 && delta < 0) {
        const active = instance.slides[instance.activeIndex];
        handleStaticSlide(instance, active, 'first');
      }

      blockScroll();
    });

    verticalInstances.push(instance);
  });

  // Всі горизонтальні контейнери
  const horizontals = document.querySelectorAll('.swiper.horizontal');
  horizontals.forEach(el => {
    const instance = new Swiper(el, {
      direction: 'horizontal',
      mousewheel: {
        sensitivity: 1,
        thresholdDelta: 60,
        thresholdTime: DURATION + 100,
      },
      modules: [Mousewheel],
      nested: true,
      speed: DURATION,
      slidesPerView: 1,
      simulateTouch: false,
      touchReleaseOnEdges: true,
    });

    instance.on('slideChangeTransitionStart', () => {
      if (isProgrammaticSlide) return;
      lockSwipers(verticalInstances, true);
    });
    instance.on('slideChangeTransitionEnd', () => {
      if (isProgrammaticSlide) {
        isProgrammaticSlide = false;
        return;
      }
      lockSwipers(verticalInstances, false);
    });

    instance.on('slidePrevTransitionStart', () => {
      const active = instance.slides[instance.activeIndex + 1];
      handleStaticSlide(instance, active, 'prev');
    });
    instance.on('slideNextTransitionStart', () => {
      const active = instance.slides[instance.previousIndex];
      handleStaticSlide(instance, active, 'next');
    });

    horizontalInstances.push(instance);
  });
}

function disableSwiper() {
  verticalInstances.forEach(swiper => swiper.destroy(true, true));
  verticalInstances = [];

  horizontalInstances.forEach(swiper => swiper.destroy(true, true));
  horizontalInstances = [];
}

function checkScreen() {
  if (window.innerWidth > 960) {
    enableSwiper();
  } else {
    disableSwiper();
  }
}

window.addEventListener('resize', () => {
  checkScreen();
  initMenuNavigation([...verticalInstances, ...horizontalInstances]);
});
document.addEventListener('DOMContentLoaded', () => {
  checkScreen();
  initMenuNavigation([...verticalInstances, ...horizontalInstances]);
  handleHashNavigation([...verticalInstances, ...horizontalInstances]);
});
